class VideoPopup extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector('.video-section__poster');
    this.popupOverlay = this.querySelector('.video-popup-overlay');
    this.closeButton = this.querySelector('.close-btn');
    this.video = this.querySelector('video');
    this.iframeYoutube = document.getElementById('youtube-player');
    this.iframeVimeo = document.getElementById('vimeo-player');
  }

  connectedCallback() {
    this.playButton.addEventListener('click', () => {
      this.popupOverlay.classList.add('active');
      this.video.play();
    });

    this.closeButton.addEventListener('click', () => {
      this.popupOverlay.classList.remove('active');
      if (this.video) {
        this.video.pause(); // Pause video
        this.video.currentTime = 0; // Reset video to start
      }
      if (this.iframeYoutube) {
        this.pauseYouTubeVideo(this.iframeYoutube);
      }
      if (this.iframeVimeo) {
        this.pauseYouTubeVideo(this.iframeVimeo);
      }
    });

    this.popupOverlay.addEventListener('click', (e) => {
      if (e.target === this.popupOverlay) {
        this.popupOverlay.classList.remove('active');
        this.video.pause();
        this.video.currentTime = 0;
      }
    });
  }

  pauseYouTubeVideo(iframe) {
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: []
      }),
      '*'
    );
  }
}

if (!window.customElements.get("video-popup")) {
    window.customElements.define("video-popup", VideoPopup);
}
